import {mobileActive} from "./handle-mobile";
import eventBus from "./event-bus";

function offcanvasMenu() {

    if (mobileActive.status) {

        let newTitles = [];
        let navBtn = $("[role='navBtn']").find('.is-icon-has-children');
        let menuRoot = $('.is-offcanvas-menu');
        let menuBackBtn = $('.js-offcanvas-menu-back');

        function makeBreadcrumb(e) {
            newTitles.push($(e.target).closest('a').find('.text-truncate').text().trim());
            $(e.target).closest(menuRoot).data('titles', newTitles);
        }


        function setMenuTitleUp(e) {
            setTimeout(() => {
                $(e.target).closest('.offcanvas').find('.offcanvas-title').text($(e.target).closest('a').find('.text-truncate').text().trim());
            }, 300)
        }

        function setMenuTitleDown(e) {
            setTimeout(() => {
                $(e.target).siblings('.offcanvas-title').text(newTitles[newTitles.length - 1]);
            }, 300)
        }

        function setDefaultTitle(e) {
            setTimeout(() => {
                let text = $(e.target).siblings('.offcanvas-title').data('main-title');
                $(e.target).siblings('.offcanvas-title').text(text);
            }, 300)
        }

        function activateNextLevel(e) {
            $(e.target).parents('.is-nav-item').children('.is-nav-list').addClass('active');
        }

        function moveMenu(e) {
            let menuRootEl = $(e.target).closest(menuRoot);
            let menuState = parseInt(menuRootEl.data('active'));

            menuRootEl.removeClass(`offcanvas-level-active-${parseInt(menuState)}`);
            menuRootEl.data('active', menuState + 1);

            if (menuState + 1 === 1) {
                removeBackButton(e);
            }

            let currentBtnState;

            const attr = $(e.target).closest('[role=navBtn]').attr('data-level');

            if (typeof attr !== 'undefined' && attr !== false) {
                currentBtnState = $(e.target).closest('[role=navBtn]').data('level');
            }

            menuRootEl.addClass(`offcanvas-level-active-${parseInt(currentBtnState + 1)}`);

            e.stopPropagation();

        }

        function removeBackButton(e) {
            $(e.target).closest('.offcanvas').find('.offcanvas-header').removeClass('has-back-button');
        }

        function addBackButton(e) {
            $(e.target).closest('.offcanvas').find('.offcanvas-header').addClass('has-back-button');
        }

        function setActiveMenuState(e) {
            makeBreadcrumb(e);
            moveMenu(e);
            setMenuTitleUp(e);
            activateNextLevel(e);
        }

        function goStepBack(e) {

            if (newTitles.length > 0) {
                let menuRootEl = $(e.target).closest('.offcanvas').find(menuRoot);
                let menuState = menuRootEl.data('active');
                menuRootEl.removeClass(`offcanvas-level-active-${parseInt(menuState)}`);

                newTitles.pop();
                let newMenuState = parseInt(menuState) - 1;

                if (menuState - 1 === 0) {
                    addBackButton(e);
                }

                menuRootEl.data('active', newMenuState);
                menuRootEl.addClass(`offcanvas-level-active-${newMenuState}`);
                menuRootEl.find(`.is-nav-list.offcanvas-level-${menuState}`).removeClass('active');

            }

            if (newTitles.length >= 1) {
                setMenuTitleDown(e);
                return
            }
            setDefaultTitle(e);
        }

        navBtn.on('click', function (e) {
            setActiveMenuState(e);
        });

        menuBackBtn.on('click', function (e) {
            goStepBack(e);
        });


    }

}

offcanvasMenu();

eventBus.on('init-main-menu', function () {
    offcanvasMenu();
});
